import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import axios from "../../../../services/axios";
import { UsersManagementProps } from "../../../../pages/v2/UsersPage";
import { ClassExtended } from "../../../../interfaces";
import { logger } from "../../../../services/logger";
import { Button } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  newPosOfDialog: {
    paddingTop: "32px",
    paddingBottom: "32px",
    paddingLeft: "40px",
    paddingRight: "40px",
    width: "35%",
    minWidth: "400px",
    minHeight: "200px",
    backgroundColor: "#FFF8F2",
    border: "1px solid #FD8211",
    boxShadow: "0px 3px 20px #00000014",
    borderRadius: "20px",
  },
  dialogTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#191919",
    marginBottom: "24px",
  },
  dialogText: {
    fontSize: "15px",
    color: "#5D5D5D",
    marginBottom: "33px",
  },
  label: {
    fontWeight: "bold",
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "16px",
  },
}));

export interface ClassDeletePromptProps extends UsersManagementProps {
  promptOpen: boolean;
  promptOnClose: () => void;
  classe?: ClassExtended;
}

export type ClassRequest = Pick<
  ClassExtended,
  "end_date" | "period_block" | "subject" | "teacher_id" | "start_date"
>;

export const ClassDeletePrompt = (props: ClassDeletePromptProps) => {
  const classes = useStyles();

  const { promptOnClose, promptOpen, classe } = props;

  const deleteClass = async (classn: ClassExtended | undefined) => {
    if (!classn) return;
    const id = props?.classe?.id;

    if (!id) return;
    axios
      .delete("/class", {
        data: { id },
      })
      .then((res) => {
        const message = `Deleted class, result: Success.`;
        props.onDelete({ message, severity: "success" });
      })
      .catch((err) => {
        logger.error(err);
        const message = `Delete class, result: Failed.`;
        props.onDelete({ message, severity: "error" });
      });
    promptOnClose();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      classes={{
        paper: classes.newPosOfDialog,
      }}
      onClose={promptOnClose}
      aria-labelledby="simple-dialog-title"
      open={promptOpen}>
      <div className={classes.dialogTitle}>
        Are you sure you want to delete the following Class? This will effect any users
        associated with the class.
      </div>
      <div className={classes.dialogText}>
        <p>
          <span className={classes.label}>Subject:</span> {classe?.course_name}
        </p>
        <p>
          <span className={classes.label}>Teacher:</span>{" "}
          {classe ? classe?.user?.full_name : ""}
        </p>
      </div>
      <div className={classes.buttonWrapper}>
        <Button variant="outlined" size="medium" onClick={promptOnClose}>
          No
        </Button>
        <Button
          variant="contained"
          size="medium"
          onClick={(event) => deleteClass(classe)}>
          Yes, delete this Class
        </Button>
      </div>
    </Dialog>
  );
};
